import React from 'react';
export function useToggle(defaultState) {
  if (defaultState === void 0) {
    defaultState = false;
  }

  var _a = React.useState(defaultState),
      state = _a[0],
      setState = _a[1];

  return [state, function () {
    return setState(!state);
  }];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/shared/hooks.js
// module id = 802
// module chunks = 0